import React from 'react';
import AgGrid from '../../shared/agGrid/agGrid.component';
import withPillNavigation from '../../shared/withPillNavigation.decorator';
import { getColumnDefinitions } from './columnDefinitions';
import { getPillDefinitions, PillTypes } from './constants';
import { useDiagnosticsQueries } from './useDiagnostics';

type DataGridProps = {
  activePill: PillTypes,
  periodName: string,
};

const DataGrid = ({ activePill, periodName }: DataGridProps) => {
  const {
    isLoading: { [activePill]: isLoading },
    data: { [activePill]: diagnosticsData },
  } = useDiagnosticsQueries(periodName, activePill);

  const columnDefinitions = getColumnDefinitions()[activePill];

  return (
    <div className="ag-grid-full-page-with-secondary-menu">
      <AgGrid
        columnDefs={columnDefinitions}
        rowData={diagnosticsData}
        headerHeight={60}
        isGridLoading={isLoading}
        withSearchBar
      />
    </div>
  );
};

export default withPillNavigation(getPillDefinitions)(DataGrid);
